import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ItemsAdd from "./ItemsAdd";
import moment from "moment";

function FixedAssets(props) {
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formData, setFormData] = useState({
    assetName: "",
    description: "",
    physicalLocation: "",
    assetNo: "",
    serialNo: "",
    acquisitionDate: null,
    acquisitionCost: "",
    estimatedUsefulLife: "",
    estimatedSalvageValue: "",
    yearOfDepreciation: "",
    estimatedFixedDecliningDepreciationValue: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
      setValidated(false);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      bodyFormData.append("po_id", props.rowData.id);
      bodyFormData.append("asset_name", formData.assetName);
      bodyFormData.append("description", formData.description);
      bodyFormData.append("physical_location", formData.physicalLocation);
      bodyFormData.append("asset_no", formData.assetNo);
      bodyFormData.append("serial_no", formData.serialNo);
      bodyFormData.append(
        "equisition_date",
        moment(formData.acquisitionDate).format("YYYY-MM-DD")
      );
      bodyFormData.append("equisition_cost", formData.acquisitionCost);
      bodyFormData.append("estimated_life", formData.estimatedUsefulLife);
      bodyFormData.append("estimated_salvage", formData.estimatedSalvageValue);
      bodyFormData.append("depreciation_year", formData.yearOfDepreciation)
      bodyFormData.append("estimate_fix_decline_depreciation_value", formData.estimatedFixedDecliningDepreciationValue);

      utils
        .callAPI("post", `/purchaseorder/add-accountant`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4>Fixed Assets Purchase Order</h4>
          <div className="card-header-action">
            <Link
              className="btn btn-underline me-2"
              onClick={props.onBackClick}
            >
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formAssetName"
                    label="Asset Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Asset Name"
                      name="assetName"
                      value={formData.assetName}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formDescription"
                    label="Description"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      placeholder="Enter Description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formPhysicalLocation"
                    label="Physical Location"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Physical Location"
                      name="physicalLocation"
                      value={formData.physicalLocation}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formAssetNo"
                    label="Asset No."
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Asset No."
                      name="assetNo"
                      value={formData.assetNo}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formSerialNo"
                    label="Serial No."
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Serial No."
                      name="serialNo"
                      value={formData.serialNo}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3 mt-3">
                  <DatePicker
                    selected={formData.acquisitionDate}
                    onChange={(date) =>
                      setFormData((prevData) => ({
                        ...prevData,
                        acquisitionDate: date,
                      }))
                    }
                    className="form-control"
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Acquisition Date"
                  />
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formAcquisitionCost"
                    label="Acquisition Cost"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Acquisition Cost"
                      name="acquisitionCost"
                      value={formData.acquisitionCost}
                      onChange={handleInputChange}
                      //   onChange={(e) => {
                      //     const { name, value } = e.target;
                      //     if (/^\d*$/.test(value)) {
                      //       handleInputChange({ target: { name, value } });
                      //     }
                      //   }}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formEstimatedUsefulLife"
                    label="Estimated Useful Life (Years)"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Estimated Useful Life"
                      name="estimatedUsefulLife"
                      value={formData.estimatedUsefulLife}
                      //   onChange={(e) => {
                      //     const { name, value } = e.target;
                      //     if (/^\d*$/.test(value)) {
                      //       handleInputChange({ target: { name, value } });
                      //     }
                      //   }}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formEstimatedSalvageValue"
                    label="Estimated Salvage Value"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Estimated Salvage Value"
                      name="estimatedSalvageValue"
                      value={formData.estimatedSalvageValue}
                      //   onChange={(e) => {
                      //     const { name, value } = e.target;
                      //     if (/^\d*$/.test(value)) {
                      //       handleInputChange({ target: { name, value } });
                      //     }
                      //   }}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formYearOfDepreciation"
                    label="Year of Depreciation"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Year of Depreciation"
                      name="yearOfDepreciation"
                      value={formData.yearOfDepreciation}
                      //   onChange={(e) => {
                      //     const { name, value } = e.target;
                      //     if (/^\d*$/.test(value)) {
                      //       handleInputChange({ target: { name, value } });
                      //     }
                      //   }}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="formEstimatedFixedDecliningDepreciationValue"
                    label="Estimated Fixed-Declining Depreciation Value"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Estimated Fixed-Declining Depreciation Value"
                      name="estimatedFixedDecliningDepreciationValue"
                      value={formData.estimatedFixedDecliningDepreciationValue}
                      //   onChange={(e) => {
                      //     const { name, value } = e.target;
                      //     if (/^\d*$/.test(value)) {
                      //       handleInputChange({ target: { name, value } });
                      //     }
                      //   }}
                      onChange={handleInputChange}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default FixedAssets;
